<template>
    <div class="memberImport pages">
        <div class="title mb-30">
            <p>
                <img src="../../assets/images/newIcon/grouplabel_icon.png" alt="">
                <span>标签组</span>
            </p>
            <p>
               
            </p>
        </div>
        <div class="f3">
            <div class="ipt">
                <p>
                    <el-input
                    class="iptRdio"
                    placeholder="输入标签组名称搜索"
                    suffix-icon="el-icon-search"
                    v-model="query.keyword_search"
                    ></el-input>
                </p>
                <p>
                    <el-button @click="addLabel(1)" type="primary" round><img src="../../assets/images/newIcon/addlabelgroup_icon.png" alt=""> 新增标签组</el-button>
                </p>
            </div>
            <el-table
            :data="tableData3"
            :header-cell-style="{background:'#EEEEEE',textAlign: 'center',fontSize:'12px'}"
            :cell-style="{textAlign: 'center',fontSize:'12px'}"
            style="width: 100%;"
            >
            <el-table-column
            prop="name"
            label="标签组名称"
            >
            </el-table-column>
            <el-table-column
            prop="number"
            show-overflow-tooltip
            label="标签数量"
            >
            </el-table-column>
            <el-table-column
            prop="xmember"
            label="规则标签数量"
            cell-style="background:red;"
            >
            </el-table-column>
            <el-table-column
            prop="lmember"
            label="运营标签数量"
            >
            </el-table-column>
            <el-table-column
            prop="labellv"
            label="操作"
            >
                <template slot-scope="scope">
                    <el-button type="text" @click="editLabel">编辑</el-button>
                    <el-button type="text" @click="del">删除</el-button>
                </template>
            </el-table-column>
            </el-table>
        </div>
        <div class="page">
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            style="margin-top: 24px;"
            :current-page="query.page_index"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="query.page_size"
            layout="prev, pager, next, sizes, jumper"
            :total="total"
            ></el-pagination>
        </div>
        <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        width="30%">
            <div class="formTab">
                <el-form ref="form" :model="form" label-width="120px">
                    <el-form-item label="标签组名称 ：">
                        <el-input class="radios" v-model="form.name" placeholder="请输入标签组名称"></el-input>
                    </el-form-item>
                    <el-form-item v-if="type==2" label="标签 ：">
                        <el-button @click="showPopup(5)"  type="text" icon="el-icon-plus">添加标签</el-button>
                        <div>
                            <el-tag size="medium" closable>沈阳市</el-tag>
                            <el-tag size="medium" closable>沈阳市</el-tag>
                            <el-tag size="medium" closable>沈阳市</el-tag>
                            <el-tag size="medium" closable>沈阳市</el-tag>
                            <el-tag size="medium" closable>沈阳市</el-tag>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible=false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible=false">确 定</el-button>
            </span>
        </el-dialog>
         <!-- <div id="myChartChina" :style="{width: '400px', height: '400px'}"></div> -->
        <customer-popup @doSelect='doSelect' ref="customerPopup"></customer-popup>
    </div>
</template>
<script>
const QUERY={
    keyword_search:"",
    page_index: 1,
    page_size: 10,
}
export default {
    data() {
        return {
            dialogVisible:false,
            time:"",
            type:1,
            title:"新增标签组",
            form:{
                name:"",
            },
            query:JSON.parse(JSON.stringify(QUERY)),
            tableData3: [{
                name: '默认',
                number:"100",
                xmember:"100",
                lmember:"100",
                },{
                name: '标签组1',
                number:"100",
                xmember:"100",
                lmember:"100",
                },{
                name: '标签组1',
                number:"100",
                xmember:"100",
                lmember:"100",
                },{
                name: '标签组1',
                number:"100",
                xmember:"100",
                lmember:"100",
                },{
                name: '标签组1',
                number:"100",
                xmember:"100",
                lmember:"100",
                },{
                name: '标签组1',
                number:"100",
                xmember:"100",
                lmember:"100",
                },{
                name: '标签组1',
                number:"100",
                xmember:"100",
                lmember:"100",
            },],
            total:90,
        }
    },
    methods: {
        del(){
            this.$confirm("是否确定删除", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                roundButton: true,
                type: "warning",
            }).then(() => {
                this.$message({
                type: "success",
                message: "删除成功!",
                });
            });
        },
        doSelect(){

        },
        handleSizeChange(val) {
            this.query.page_size = val;
            // this.getTableData();
        },
        handleCurrentChange(val) {
            this.query.page_index = val;
            // this.getTableData();
        },
        showPopup(type){
            this.$refs.customerPopup.show(type);
        },
        editLabel(){
            this.title="编辑标签组"
            this.type=2;
            this.dialogVisible=true;
        },
        addLabel(type){
            this.type=type;
            this.dialogVisible=true;
        },
        handleSizeChange(val) {
            this.query.page_size = val;
        },
        handleCurrentChange(val) {
            this.query.page_index = val;
        },
        drawLine() {
            // 基于准备好的dom，初始化echarts实例
            var myChartContainer = document.getElementById('myChartChina')
            var resizeMyChartContainer = function() {
                myChartContainer.style.width = (document.body.offsetWidth / 2) + 'px' // 页面一半的大小
            }
            resizeMyChartContainer()
            var myChartChina = this.$echarts.init(myChartContainer)
            function randomData() {
            return Math.round(Math.random() * 500)
            }
             let data=[{"id":1,"area_id":110000,"parent_id":-1,"area_name":"北京市","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":0,"center":0,"area_code":0},{"id":19,"area_id":120000,"parent_id":-1,"area_name":"天津市","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":0,"center":0,"area_code":0},{"id":37,"area_id":130000,"parent_id":-1,"area_name":"河北省","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":217,"area_id":140000,"parent_id":-1,"area_name":"山西省","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":346,"area_id":150000,"parent_id":-1,"area_name":"内蒙古自治区","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":462,"area_id":210000,"parent_id":-1,"area_name":"辽宁省","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":577,"area_id":220000,"parent_id":-1,"area_name":"吉林省","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":647,"area_id":230000,"parent_id":-1,"area_name":"黑龙江省","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":789,"area_id":310000,"parent_id":-1,"area_name":"上海市","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":807,"area_id":320000,"parent_id":-1,"area_name":"江苏省","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":917,"area_id":330000,"parent_id":-1,"area_name":"浙江省","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":1018,"area_id":340000,"parent_id":-1,"area_name":"安徽省","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":1140,"area_id":350000,"parent_id":-1,"area_name":"福建省","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":1235,"area_id":360000,"parent_id":-1,"area_name":"江西省","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":1347,"area_id":370000,"parent_id":-1,"area_name":"山东省","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":1502,"area_id":410000,"parent_id":-1,"area_name":"河南省","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":1677,"area_id":420000,"parent_id":-1,"area_name":"湖北省","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":1790,"area_id":430000,"parent_id":-1,"area_name":"湖南省","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":1927,"area_id":440000,"parent_id":-1,"area_name":"广东省","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":2071,"area_id":450000,"parent_id":-1,"area_name":"广西壮族自治区","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":2197,"area_id":460000,"parent_id":-1,"area_name":"海南省","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":2210,"area_id":500000,"parent_id":-1,"area_name":"重庆市","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":2250,"area_id":510000,"parent_id":-1,"area_name":"四川省","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":2455,"area_id":520000,"parent_id":-1,"area_name":"贵州省","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":2553,"area_id":530000,"parent_id":-1,"area_name":"云南省","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":2699,"area_id":540000,"parent_id":-1,"area_name":"西藏自治区","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":2781,"area_id":610000,"parent_id":-1,"area_name":"陕西省","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":2899,"area_id":620000,"parent_id":-1,"area_name":"甘肃省","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":3000,"area_id":630000,"parent_id":-1,"area_name":"青海省","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":3053,"area_id":640000,"parent_id":-1,"area_name":"宁夏回族自治区","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":3081,"area_id":650000,"parent_id":-1,"area_name":"新疆维吾尔自治区","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":3192,"area_id":710000,"parent_id":-1,"area_name":"台湾省","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":3195,"area_id":810000,"parent_id":-1,"area_name":"香港特别行政区","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null},{"id":3198,"area_id":820000,"parent_id":-1,"area_name":"澳门特别行政区","level":1,"create_time":"2019-06-11 14:19:40","update_time":"2020-11-21 00:16:33","city_code":null,"center":null,"area_code":null}]
            // 绘制图表
            var optionMap = {
            tooltip: {
                trigger: 'item',
                formatter: '{b}：{c}'
            },
            // legend: {
            //   orient: 'vertical',
            //   left: 'left',
            //   data: ['']
            // },

            visualMap: {
                min: 0,
                max: 1500,
                orient: 'horizontal',
                right: 'auto',
                top: 'bottom',
                text: ['高', '低'],
                calculable: true,
                color: ['#0b50b9', '#c3e2f4']
            },
            selectedMode: 'single',
            series: [{
                name: '',
                type: 'map',
                top: '2%',
                // left: '10%',
                // right: '10%',
                bottom: '2%',
                mapType: 'china',
                itemStyle: {
                normal: {
                    borderColor: 'rgba(0, 0, 0, 0.2)'
                },
                emphasis: {
                    shadowOffsetX: 0,
                    shadowOffsetY: 0,
                    shadowBlur: 20,
                    borderWidth: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
                },
                showLegendSymbol: true,
                label: {
                normal: {
                    show: true
                },
                emphasis: {
                    show: true
                }
                },
                data: data
            }]
            }

            myChartChina.setOption(optionMap)
            window.onresize = function() {
            resizeMyChartContainer()
            myChartChina.resize()
            }
        }
    },
    mounted(){
        this.drawLine();
    }
}
</script>
<style lang="less" scoped>
    .title{
        display: flex;
        justify-content: space-between;
        p{
            font-size: 16px;
            font-weight: 500;
            color: #333940;
            img{
                margin-right:10px;
                width:20px;
                height:20px;
                vertical-align: middle;
                &:last-child{
                    margin-left:10px;
                    width:78px;
                    height:20px;
                }
            }
            &:last-child{
                span{
                    color: #0091FF;
                }
            }
            
        }
    }
    .radios {
        /deep/ .el-input__inner{
            background: #F6F6F6;
            border-radius: 18px;
            border:0px;
        }
    }
    .memberImport{
        .dialog-footer{
            display: block;
        
            .el-button{
                border-radius: 30px;
            }
        }
        /deep/ .el-dialog__footer{
            border-top:1px solid #ededed;
        }
        border-radius:10px;
        .f3{
                background: #ffff;
                .ipt{
                    padding:15px;
                    display: flex;
                    justify-content: space-between;
                    /deep/.el-input .el-input__inner{
                        border-radius: 30px;
                        background: #F6F6F6;
                        border: 0px;
                    }
                    /deep/ .el-select>.el-input{
                        width:160px;
                    }
                    .iptRdio{
                        margin-right: 15px;
                    }
                    p{
                        display: flex;
                        img{
                            width:16px;
                            vertical-align: middle;
                        }
                    }
                }
                
                /deep/ .el-button{
                    margin-right:10px;
                }
        }
        .formTab{
            padding:30px;
            /deep/ .el-tag{
                border-radius: 30px;
                margin-right:10px;
                margin-bottom:10px;
            }
        }
        .times.el-input__inner{
            border-radius: 30px;
            width:100%;
            // height:38px;
            background: #F7F7F7;
            .el-range-separator{
                font-size:16px;
                color:#ccc;
                line-height: 28px;
            }
        }
        /deep/ .times .el-range-input{
            background: #F7F7F7;
        }
        /deep/ .el-range-separator{
            color:#ccc;
        }
    }
</style>